import { OnboardingLevel } from '@shared/graphql'

import type { TermsOfServiceContentProps } from '@circlefin/components/lib/TermsOfService/Content/TermsOfServiceContent'

export enum MsaModalType {
  core = 'core',
  trade = 'trade',
}

export const MsaModalTypeToOnboardingLevel = {
  [MsaModalType.core]: OnboardingLevel.LEVEL_3_CORE_MSA,
  [MsaModalType.trade]: OnboardingLevel.LEVEL_3_TRADE_MSA,
}

export const msaSanitizeOptions: Required<TermsOfServiceContentProps>['sanitizeOptions'] =
  ({ defaults, simpleTransform }) => ({
    // allow style attributes
    allowedTags: defaults.allowedTags.concat(['style']),
    // we need to apply the styles sent across
    allowVulnerableTags: true,
    parseStyleAttributes: true,
    allowedAttributes: {
      ol: ['type'],
      a: ['href', 'target', 'rel'],
      '*': ['class'],
    },
    // all links open in a new tab
    transformTags: {
      a: simpleTransform('a', {
        target: '_blank',
        rel: 'noopener noreferrer',
      }),
    },
  })
